export const JWP_ICV_INJECT = {
	name: 'JWP icv inject',
} as const;

export const JWP_ICV_READY = {
	name: 'JWP icv ready',
} as const;
